import { render, staticRenderFns } from "./GalleryListDefaultLayout.vue?vue&type=template&id=182408c3&scoped=true&"
import script from "./GalleryListDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./GalleryListDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182408c3",
  null
  
)

export default component.exports